import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from '@/components/ui/carousel';
import { galleryImages } from '@/data/mock';

export const GalleryCarousel = () => {
  return (
    <section className="py-24 bg-[var(--surface-cream)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-sm uppercase tracking-wider text-[var(--color-gold)] font-medium mb-4">
            Galerie
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[var(--text-primary)] mb-6">
            Nos Compagnons
          </h2>
          <div className="w-24 h-px bg-[var(--color-gold)] mx-auto"></div>
        </div>

        {/* Carousel */}
        <div className="px-12">
          <Carousel
            opts={{
              align: 'start',
              loop: true,
            }}
            className="w-full"
          >
            <CarouselContent className="-ml-4">
              {galleryImages.map((image) => (
                <CarouselItem key={image.id} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div className="gallery-image aspect-[4/5] rounded-2xl overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="mt-4 text-center">
                    <span className="inline-block px-3 py-1 bg-white rounded-full text-xs uppercase tracking-wider text-[var(--text-subtle)]">
                      Maine Coon
                    </span>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="-left-4 bg-white hover:bg-[var(--color-gold)] hover:text-white border-[var(--color-beige)]" />
            <CarouselNext className="-right-4 bg-white hover:bg-[var(--color-gold)] hover:text-white border-[var(--color-beige)]" />
          </Carousel>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/maine-coon">
              <Button variant="outline" className="btn-outline group">
                Découvrir nos Maine Coons
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="btn-outline group">
                Nous contacter
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
